/**
 * Display helpers shared by the marketplace payment and dispute pages. Every helper accepts a missing value
 * (`null` / `undefined`, since payment models leave unsent fields `undefined`) and renders it as an em dash.
 */

const DATE_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
};

/** US dollars, e.g. `$1,234.50`. */
export function formatPaymentMoney(value: number | null | undefined): string {
  if (value == null) return '—';
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

/** Acres to 2 decimals with trailing zeros stripped, e.g. `33.3`; with `unit`, `33.3 ac`. */
export function formatPaymentAcres(value: number | null | undefined, unit: boolean = true): string {
  if (value == null) return '—';
  const acres = value.toFixed(2).replace(/\.?0+$/, '');
  return unit ? `${acres} ac` : acres;
}

/** An ISO string or `Date` as e.g. `Jun 11, 2026, 3:04 PM`. */
export function formatPaymentDateTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('en-US', DATE_TIME_FORMAT);
}

/** The first 8 characters of an id plus an ellipsis. */
export function shortPaymentId(id: string | null | undefined): string {
  if (!id) return '—';
  return id.length > 8 ? id.slice(0, 8) + '…' : id;
}
